module.exports = __webpack_public_path__ + "img/sport8_hover.b175bacc.png";